import * as swcHelpers from '@swc/helpers';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getProductUrl } from '../../../utils/get-line-item-product-url.js';
import { getLocalizedString } from '../../../utils/get-localized-string.js';
import { getSharedProps } from '../../../utils/shared-line-item-data-mapper.js';
import { getBundledLineItemProductVariant } from './utils/bundles/get-bundled-line-item-product-variant.js';
import { findBundledLineItem } from './utils/prescription-glasses/find-bundled-line-item.js';
import { getBundledFrameInfo } from './utils/prescription-glasses/get-bundled-frame-info.js';
import { getBundledProductInfo } from './utils/prescription-glasses/get-bundled-product-info.js';
import { getPrescription } from './utils/prescription-glasses/get-prescription.js';
import { getLineItemCartDiscountDescription } from './utils/prescription-glasses/get-line-item-cart-discount-description.js';

const mapPrescriptionGlassesLineItem = (lineItemRaw, settings, intl)=>{
    var ref, ref1, ref2, ref3;
    const mainBundleLineItem = lineItemRaw.bundleLineItems.find((bundleLineItem)=>bundleLineItem.isMainBundleLineItem
    );
    if (!mainBundleLineItem) {
        console.error(`None of the bundleLineItems have isMainBundleLineItem in LineItemBundle with id ${lineItemRaw.id}`);
        return null;
    }
    const lensTypeBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'LensTypes');
    const lensPackageBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'PrescriptionGlassPackages');
    if (!lensTypeBundleLineItem || !lensPackageBundleLineItem) {
        console.error(`Either lensTypeBundleLineItem or lensPackageBundleLineItem are missing from LineItemBundle with id ${lineItemRaw.id}`);
        return null;
    }
    const prescriptionTypeDetails = lineItemRaw.typeDetails;
    const addOnBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'PrescriptionGlassPackageOptions');
    const shared = getSharedProps(lineItemRaw, mainBundleLineItem.legacyProduct, intl);
    // Assumes the frame is the main bundled line item
    const frame = getBundledFrameInfo(lineItemRaw, mainBundleLineItem, intl);
    const lensType = getBundledProductInfo(lensTypeBundleLineItem, intl);
    const lensPackage = getBundledProductInfo(lensPackageBundleLineItem, intl);
    const addOn = !!addOnBundleLineItem ? getBundledProductInfo(addOnBundleLineItem, intl) : undefined;
    // Product discounts
    const frameDiscount = ((ref = frame.price) === null || ref === void 0 ? void 0 : ref.discount) || 0;
    const lensTypeDiscount = ((ref1 = lensType.price) === null || ref1 === void 0 ? void 0 : ref1.discount) || 0;
    const lensPackageDiscount = ((ref2 = lensPackage.price) === null || ref2 === void 0 ? void 0 : ref2.discount) || 0;
    const addOnDiscount = (addOn === null || addOn === void 0 ? void 0 : (ref3 = addOn.price) === null || ref3 === void 0 ? void 0 : ref3.discount) || 0;
    const totalProductDiscount = shared.quantity * (frameDiscount + lensTypeDiscount + lensPackageDiscount + addOnDiscount);
    // Total discount (cart discount + (all product discounts * quantity))
    const totalDiscount = shared.price.total.discount;
    const slug = getLocalizedString(intl.locale, mainBundleLineItem.legacyProduct.masterData.current.slug);
    const variant = getBundledLineItemProductVariant(mainBundleLineItem);
    return swcHelpers.objectSpread({}, shared, {
        type: 'prescription-glasses',
        name: frame.title,
        imageAlt: frame.title,
        frame,
        mainBundleItemPrice: frame === null || frame === void 0 ? void 0 : frame.price,
        imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled),
        lensType,
        lensPackage,
        addOn,
        productUrl: getProductUrl(settings.productLinkFormatter, lineItemRaw, slug, intl.locale),
        prescription: getPrescription(prescriptionTypeDetails)
    }, !!totalDiscount ? {
        cartDiscount: {
            amount: totalDiscount - totalProductDiscount,
            description: getLineItemCartDiscountDescription(lineItemRaw, intl.locale)
        }
    } : {});
};

export { mapPrescriptionGlassesLineItem };
//# sourceMappingURL=prescription-glasses.js.map
